import Link from "next/link";
import warningIcon from "@/assets/icons/warningIcon.svg";
import Image from "next/image";
import arrow from "@/assets/icons/arrow-down.svg";
interface AllergyCityCardProps {
  title: string;
  description: string;
  link: string;
  variant: "us" | "uk";
}

const AllergyCityCard: React.FC<AllergyCityCardProps> = ({
  title,
  description,
  link,
  variant,
}) => {
  return (
    <Link
      href={link}
      className="bg-neutral-dark-200 rounded-lg p-8 gap-y-8 flex flex-col hover:bg-neutral-dark-100 transition-all self-stretch h-full"
    >
      <div className="text-secondary-100">
        <Image src={warningIcon} alt="warning" />
      </div>
      <div className="flex flex-col gap-y-9 flex-grow">
        <div className="flex flex-col gap-y-3">
          <h3 className="text-neutral-light-200 font-semibold">
            {title}
          </h3>
          <p className="text-neutral-light-800 text-sm lg:text-lg font-medium">
            {description}
          </p>
        </div>
        <section className="text-sm lg:text-base mt-auto text-secondary-100 hover:text-secondary-200 transition-colors flex items-center space-x-2 font-poppinsRegular">
          <span>
            {link.includes("worst") || link.includes("most")
              ? link.includes("polluted")
                ? "See Most Polluted Cities"
                : "See Worst Pollen Cities"
              : link.includes("polluted")
              ? "See Least Polluted Cities"
              : "See Low Allergy Cities"}
          </span>
          <span className="inline-block w-6 h-6 relative">
            <Image
              src={arrow}
              alt="arrow"
              fill
              className="object-contain -rotate-90"
            />
          </span>
        </section>
      </div>
    </Link>
  );
};

export default AllergyCityCard;
